module.exports = __webpack_public_path__ + "img/ywy_1.93c52d75.png";